export default __webpack_public_path__ + "content/media/31.2eefaf81.jpg";